import React, { useEffect, useState } from 'react';
import { Accordion, Box, Text, Badge, Group, Button, Divider, createStyles, Center, Loader } from '@mantine/core';
import { IconDownload, IconDots } from '@tabler/icons-react';
import CustomBreadcrumbs from '../../../components/CustomBreadCrumbs';
import ProgressTracker, { ProgressStep } from './Steps';
import { PatientDetails } from './CustomCards';
import InsuranceInfo from './GenericInsuranceInfo';
import { formatDate } from '@medplum/core';
import CustomAccordion from './CustomAccordian';
import { useMedplum } from '@medplum/react';
import { ClaimResponse } from '@medplum/fhirtypes';
import { getEdiFiles, getUpdatedClaimRes, runTimer } from './ClaimService';
import { batch } from 'react-redux';
import { getPatientName } from '../EligibiltyService';

const useStyles = createStyles((theme) => ({

  default: {
    borderRadius: "8px",
    marginLeft: "30px",
    marginRight: "30px",
    padding: "16px",
    marginTop: "16px",
  },
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  box1: {
    borderRadius: "8px",
    padding: "16px",
    gap: "32px", backgroundColor: "white",
  }, box2: {
    display: "flex",
    justifyContent:"center",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: "white",
    height: "100%",
    width: "100%",
  },
  box3: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: "white",
  }, text: { border: "1px solid #ddd", borderRadius: "5px", padding: "12px", marginTop: "16px" },


}));
interface StepData {
  currentProgress: number;
  isComplete: boolean;
}

export const ClaimDetails: React.FC = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [currentStep, setCurrentStep] = useState(0);
  const [patientDetail, setPatientDetail] = useState<any>()
  const [payerDetails, setPayerDetails] = useState<any>()
  const [currentTab, setCurrentTab] = useState<any>('details')
  const [selectEligibilityDetails, setSelectedEligibilityDetails] = useState<any>()
  const [claimRes, setClaimRes] = useState<any>({});
  const [pat, setPat] = useState<any>({});
  const [prov, setProv] = useState<any>({});
  const [payer, setPayer] = useState<any>({});
  const [preAuth, setPreAuth] = useState<any>({});
  const [isFetching, setIsFetching] = useState(true);
  const [accordianData, setAccordianData] = useState<any>([]);
  // const [otherDetails,setOtherDetails]=useState<any>()
  const [fhirResponse, setFhirResponse] = useState<any>()
  // State to track progress for each step 
  const filUriList = [
    {
      definition: 'The TA1 Interchange Acknowledgement is generated when there are issues with the format or structure of the submitted EDI transaction at the interchange level. It indicates whether the interchange (ISA/IEA envelope) was accepted or rejected. The TA1 response informs the sender if there are any syntactical errors in the interchange header and trailer segments of the EDI file.',
      heading: 'Interchange Acknowledgement (TA1)',
      raw: 'TA1',
      // hr: 'ack'
    },
    {
      definition: 'The 999 Implementation Acknowledgement is used to confirm the acceptance or rejection of the submitted EDI file after validating the compliance with the HIPAA TR3 specifications. It reports syntactical errors found during the processing of the functional group (GS/GE) and transaction set (ST/SE) levels, providing detailed feedback on which part of the transaction caused the rejection if any issues are found.',
      heading: 'Implementation Acknowledgement (999)',
      raw: '999',
      hr: '99T'
    },
    {
      definition: 'The Immediate Batch Response (IBR) is a proprietary Availity report that provides immediate confirmation that the batch file was received and processed. It is an internal Availity report that offers real-time tracking and ensures the sender that the file was successfully uploaded into Availity’s system for further processing.',
      heading: 'Immediate Batch Responses (IBR)',
      raw: 'ibr',
      hr: 'ibt'
    },
    {
      definition: 'The Electronic Batch Report (EBR) provides a detailed summary of all the transactions contained in a batch submission, including the number of accepted, rejected, or pended claims or transactions. It helps in monitoring and analyzing the status of the batch file post-submission, ensuring end-to-end tracking of each claim’s lifecycle through the Availity system.',
      heading: 'Electronic Batch Report (EBR)',
      raw: 'ebr',
      hr: 'ebt'
    }
  ];

  const [stepProgress, setStepProgress] = useState<Record<number, StepData>>({
    0: { currentProgress: 0, isComplete: false },
    1: { currentProgress: 0, isComplete: false },
    2: { currentProgress: 0, isComplete: false },
    3: { currentProgress: 0, isComplete: false },
    4: { currentProgress: 0, isComplete: false },
  });
  const reportData = {
    dateReceived: '2024-10-14',
    timeReceived: '04:35:52.052',
    availityBatchId: '2024101404355200',
    fileControlNumber: '000000001',
    availityFileId: '1-285373396721',
    fileName: 'edinnew.txt',
    payerId: '592015694',
    claimResponsesReturned: 1,
    acceptedClaims: 0,
    rejectedClaims: 1,
    charges: '100.00',
    patientName: 'DOE, JOHN',
    fromDate: '20231001',
    toDate: '20231001',
    patientControlNumber: '12345',
    providerBillingId: '1234567893',
    clearinghouseTrace: 'NA',
    payerClaimNumber: 'NA',
    availityTrace: '6B530881537',
    errorDetails: {
      errorInitiator: '592015694-PSE',
      messageType: 'R',
      errorCode: '611',
      errorMessage: "Invalid value given T, must be 'P' for production",
      version: '5010A1',
      loop: '0000',
      segmentId: 'ISA',
      elementNumber: '15',
    },
    receiverFailMessage: 'RECEIVER FAIL',
  };
  const otherDetails = {
    patientAccountNumber: "123456789",
    totalCharges: "$1500.00",
    billingProviderId: "BILLPROV123",
    billingProviderApi: "API123456",
    payerClaimNumber: "CLAIM987654",
    payerId: "PAYER123",
    payerSeqNumber: "SEQ001",
    availityBatchId: "BATCH456",
    claimSequence: "SEQ-789",
    messageType: "INFO",
    messageCode: "MSG001",
    messageLoop: "LOOP1",
    messageSegment: "SEGMENT1",
    messageElement: "ELEMENT1"
  };


  useEffect(() => {
    const location = window.location.href;
    const url = new URL(location);
    const id = url.searchParams.get("id");
    if (!id) {
      // navigate("/admin/insurance/prior-auth/new?service=availity");
      return
    }
    getClaimResponse(id);

  }, []);

  useEffect(() => {
    if (!claimRes?.extension) return;
    ediFileStepFetch();
  }, [claimRes])



  const getClaimResponse = async (id: string) => {
    const claimResponse = await medplum.readResource("ClaimResponse", id);
    const [patient, provider, payer, ele, pAuth] = await Promise.all([
      medplum.readReference(claimResponse.patient),
      medplum.readReference(claimResponse.requestor as any),
      medplum.readReference(claimResponse.insurer),
      medplum.readReference(claimResponse?.extension?.find((ext) => ext.url === 'ele')?.valueReference as any),
      medplum.readResource("ClaimResponse", claimResponse.preAuthRef?.split("/")[1] ?? '')
    ])
    setClaimRes(claimResponse);
    setPat(patient);
    setProv(provider);
    setPayer(payer);
    setPreAuth(pAuth);
    setSelectedEligibilityDetails(ele);
    setIsFetching(false);
    // getEdiFiles(medplum, claimResponse, 'ack')
  }



  const ediFileStepFetch = async () => {
    runTimer(setStepProgress, 0, false);
    let filIndex = 0;
    let updatedClaimRes = await getUpdatedClaimRes(medplum, claimRes.id);
    if (!updatedClaimRes?.extension) updatedClaimRes = claimRes;
    for (let i of filUriList) {
      if (!updatedClaimRes.extension?.find((ext: any) => ext.url === i.raw || ext.url === i.hr)?.valueReference) {
        const timer = await runTimer(setStepProgress, filIndex, false);
        filIndex++
        continue;
      }
      const curr = {
        batchReport: reportData,
        heading: i.heading,
        blueSubData: i.definition,
        status: 'Completed',
      } as any;
      const timer = await runTimer(setStepProgress, filIndex, true);
      const patName = getPatientName(pat?.name)
      if (i?.raw) curr.rawData = await getEdiFiles(medplum, updatedClaimRes, i.raw, patName);
      if (i?.hr) curr.hrData = await getEdiFiles(medplum, updatedClaimRes, i.hr, patName);
      curr.dateAndTime = new Date().toLocaleString();
      setAccordianData((prev: any) => [...prev, curr]);
      filIndex++
    }
  }


  // Function to update progress for a specific step
  // const updateStepProgress = (stepIndex: number, progress: number) => {
  //   setStepProgress(prev => ({
  //     ...prev,
  //     [stepIndex]: {
  //       currentProgress: progress,
  //       isComplete: progress === 100
  //     }
  //   }));

  //   // Automatically move to next step if current step is complete
  //   if (progress === 100 && stepIndex === currentStep && currentStep < 4) {
  //     setCurrentStep(currentStep + 1);
  //   }
  // };

  // Helper function to determine step status
  const getStepStatus = (index: number): 'completed' | 'current' | 'upcoming' => {
    if (stepProgress[index]?.isComplete) return 'completed';
    if (index === currentStep) return 'current';
    return 'upcoming';
  };


  const steps: ProgressStep[] = [
    {
      label: "Interchange Acknowledgment(TA1)",
      status: getStepStatus(0),
      progress: stepProgress[0].currentProgress,
      isComplete: stepProgress[0].isComplete
    },
    {
      label: "Implementation Acknowledgment(999)",
      status: getStepStatus(1),
      progress: stepProgress[1].currentProgress,
      isComplete: stepProgress[1].isComplete
    },
    {
      label: "Immediate Batch Response(IBR)",
      status: getStepStatus(2),
      progress: stepProgress[2].currentProgress,
      isComplete: stepProgress[2].isComplete
    },
    {
      label: "Electronic Batch Report(EBR)",
      status: getStepStatus(3),
      progress: stepProgress[3].currentProgress,
      isComplete: stepProgress[3].isComplete
    },
    {
      label: 'Delayed Payer Report(DPR)',
      status: getStepStatus(4),
      progress: stepProgress[4].currentProgress,
      isComplete: stepProgress[4].isComplete
    }
  ];
  const eligibilityDetails = [
    {
      title: "Status",
      data: selectEligibilityDetails?.status ?? 'ACTIVE',
    },
    {
      title: "Payer",
      data: payer.name ?? '--',
    },
    {
      title: "Outcome",
      data: selectEligibilityDetails?.outcome ?? 'Partial',
    },
    {
      title: "Prior Auth Period",
      data: `${formatDate(preAuth?.preAuthPeriod?.start)} to ${formatDate(preAuth?.preAuthPeriod?.end)}`,
    },
    {
      title: "DOS",
      data: `${selectEligibilityDetails?.servicedPeriod?.start}  to ${selectEligibilityDetails?.servicedPeriod?.end}`,
    },
  ];

  return (
    <>
      {isFetching ? (
        <Center className={classes.loader}>
          <Loader />
        </Center>
      ) : (
        <Box className={classes.default}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%", width: "100%",
            gap: "16px",
          }}>


            <Box className={classes.box1}>
              <Box className={classes.box2}>
                <CustomBreadcrumbs />
                {/* <Box>
                  {/* < PatientDetails patient={patientDetail} coverageReesponse={payerDetails} /> */}
                  {/* import patientdetails custom card here  */}
                
              </Box>

            </Box>
            {/* edi flow ui starts here */}
            <Box className={classes.box1}>

              <Box className={classes.box3}>
                <Text weight={600} size={'18px'}>EDI Flow</Text>
                <Box sx={{ display: "flex", backgroundColor: "#FAFDFF", padding: "16px", border: "1px solid #1B75BC", borderRadius: "8px", overflowX: "auto", }}>
                  <ProgressTracker progress={true} steps={steps} />
                  {/* dropdown goes here */}

                </Box>
                <Box sx={{ display: "flex", gap: "8px", flexDirection: "column" }}>
                  {accordianData?.map((data: any, index: number) => (
                    <CustomAccordion
                      key={index}
                      batchReport={data?.batchReport}
                      blueSubData={data?.blueSubData}
                      dateAndTime={data?.dateAndTime}
                      rawData={data?.rawData}
                      hrData={data?.hrData}
                      heading={data?.heading}
                      status={data?.status}
                    />
                  ))}
                </Box>


              </Box>
            </Box>
            {/* //box3 starts from here tab ui */}

            <Box className={classes.box1}>
              <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", }}>
                <Box sx={{ display: "flex", gap: "16px" }}>
                  <Button variant={currentTab === 'details' ? 'filled' : 'outline'} onClick={() => { setCurrentTab('details') }}>
                    Details
                  </Button>
                  <Button variant={currentTab === 'fhir' ? 'filled' : 'outline'} onClick={() => { setCurrentTab('fhir') }}>
                    FHIR
                  </Button>
                </Box>
                <Box>
                  <Text>
                    Trace Id: {claimRes?.id}
                  </Text>
                </Box>
              </Box>
              <Box mt={'16px'}>
                <Divider />
              </Box>
              {currentTab === 'details' && <>
                <Box mt={'32px'} w={'100%'}>
                  <InsuranceInfo eligibilityDetails={eligibilityDetails} />

                </Box>
                <Box mt={'32px'}>
                  {/* //other details section */}
                  < PatientDetails preAuth={preAuth} patient={pat} otherDetails={otherDetails} />

                </Box>  </>}
              {currentTab === 'fhir' && <>

                <Text
                  className={classes.text}
                >{
                    !claimRes && <>No Data Found</>
                  }
                  <pre>{JSON.stringify(claimRes, null, 2)}</pre>
                </Text>


              </>}


            </Box>


          </Box>

        </Box>)}

    </>
  );
};

